import { generator } from '@cms-max/cms-browser-api-client'
import { Activity, Component } from '@cms-max/medicare-api-sdk'
import { GeneratorArgs } from './generateEventMap'

export const preventiveServicesGenerator = generator(({ i18n }: GeneratorArgs) => {
  return ({
    // Preventive Services learn more click
    ps_learncoverage_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.PreventiveServices,
        elementId: 'ps_learncoverage_click'
      }
    },
    // My Preventive Services print click
    ps_print_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.PreventiveServices,
        elementId: 'ps_print_click'
      }
    },
    // Preventive Services back to home click
    ps_backtoaccounthome_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.PreventiveServices,
        elementId: 'ps_backtoaccounthome_click'
      }
    },
    // Preventive Services get details click
    ps_getdetails_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: Component.PreventiveServices,
        elementId: 'ps_getdetails_click'
      }
    },
    // Preventive Services on load
    ps_on_load: {
      core: {
        property: 'MAX',
        activity: Activity.PageLoad,
        component: Component.PreventiveServices
      }
    }
  }) // TODO: Uncomment - jest can't handle this right now. It likely needs updated to support: satisfies GenericEventMap
})

export type preventiveServicesKeys = keyof ReturnType<typeof preventiveServicesGenerator>

export default preventiveServicesGenerator
